export default "__VITE_ASSET__3f64dae5__"